export const SIMLY_API_URL = process.env.REACT_APP_SIMLY_API_URL;
export const CAMPAIGN_ID = process.env.REACT_APP_CAMPAIGN_ID;
export const REGION_LOCK_ISO = process.env.REACT_APP_REGION_LOCK_ISO;
